import { html, raw } from '../lib/html.js';
import { isValidEmail } from '../lib/masks.js';
import { autoClearErrors, busy, setFieldError, toastError, valueOf } from '../lib/ui.js';
import { flow } from '../lib/flow.js';
import { session } from '../services/session.js';
import { auth } from '../services/auth.js';
import { config } from '../config.js';
import { googleButton, wireGoogleButton } from '../services/google.js';
import { Page, brand, go } from './base.js';

class LoginPage extends Page {
  template() {
    return html`
      <ion-content class="ion-padding auth">
        <div class="auth-wrap">
          ${raw(brand('O histórico de manutenção do seu veículo'))}
          ${raw(googleButton('Entrar com Google'))}
          <form novalidate>
            <ion-list lines="none" class="form">
              <ion-input name="email" type="email" label="E-mail" label-placement="floating" fill="outline"
                autocomplete="email" inputmode="email" autocapitalize="off"></ion-input>
              <ion-input name="password" type="password" label="Senha" label-placement="floating" fill="outline"
                autocomplete="current-password">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              </ion-input>
            </ion-list>
            <ion-button type="submit" expand="block" class="submit">Entrar</ion-button>
          </form>
          <ion-button fill="clear" expand="block" size="small" data-go="/forgot">Esqueci minha senha</ion-button>
          <div class="auth-footer">
            <ion-text color="medium">Ainda não tem conta?</ion-text>
            <ion-button fill="clear" data-go="/signup">Criar conta</ion-button>
          </div>
          <p class="app-version">versão ${config.bundleVersion}${config.appEnv === 'prd' ? '' : ` · ${config.appEnv.toUpperCase()}`}</p>
        </div>
      </ion-content>`;
  }

  setup() {
    autoClearErrors(this);
    wireGoogleButton(this);
    this.querySelectorAll('[data-go]').forEach((b) => b.addEventListener('click', () => go(b.dataset.go)));
    this.$('form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });
  }

  onEnter() {
    if (flow.email && !valueOf(this, 'email')) this.$('ion-input[name="email"]').value = flow.email;
  }

  async submit() {
    const email = valueOf(this, 'email').toLowerCase();
    const password = this.$('ion-input[name="password"]').value ?? '';
    let ok = true;
    if (!isValidEmail(email)) (ok = false), setFieldError(this.$('ion-input[name="email"]'), 'Informe um e-mail válido');
    if (!password) (ok = false), setFieldError(this.$('ion-input[name="password"]'), 'Informe a senha');
    if (!ok) return;

    await busy(this.$('.submit'), async () => {
      try {
        await session.signIn(email, password);
        flow.clear();
        this.$('ion-input[name="password"]').value = '';
        await go('/home', 'root');
      } catch (err) {
        if (err.code === 'USER_NOT_CONFIRMED') {
          flow.email = email;
          flow.password = password;
          await auth.resendCode(email).catch(() => {});
          return go('/confirm');
        }
        toastError(err.message);
      }
    });
  }
}

customElements.define('page-login', LoginPage);
